<p-panel header="{{windowsTitle}}" *ngIf="canAccessPage">
  <p-accordion [multiple]="true">
    <p-accordionTab [selected]="true" cache="false">
      <ng-template pTemplate="header">
        <h5>Переменные ценообразования</h5>
      </ng-template>
      <app-edit-price-variables-tab appStopAccordionHomeEnd></app-edit-price-variables-tab>
    </p-accordionTab>
  </p-accordion>
</p-panel>
